import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/lib/site";

export default function Services() {
  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="relative bg-[#080808] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#E63946]" />
              <span className="text-xs uppercase tracking-[0.3em] font-mono text-[#E63946]">
                / 03 — Servizi
              </span>
            </div>
            <h2 className="font-heading font-black leading-[0.9] tracking-tighter text-5xl md:text-6xl max-w-2xl">
              I Nostri Servizi
              <br />
              <span className="text-zinc-500">Principali.</span>
            </h2>
          </div>
          <p className="text-zinc-400 lg:max-w-md text-base leading-relaxed">
            Soluzioni complete per la meccanica e la carrozzeria del tuo
            veicolo. Ogni ricambio è verificato e tracciato.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-px bg-white/10">
          {SERVICES.map((s) => (
            <a
              key={s.id}
              href="#preventivo"
              data-testid={`service-${s.id}`}
              className="group relative block bg-[#0a0a0a] overflow-hidden lift"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="service-img absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/55 to-[#0a0a0a]/10" />
                <div className="absolute top-5 left-5 right-5 flex items-start justify-between">
                  <span className="font-mono text-xs text-white/80 tracking-widest">
                    / {s.n}
                  </span>
                  <span className="w-9 h-9 inline-flex items-center justify-center bg-white text-black group-hover:bg-[#E63946] group-hover:text-white transition-colors duration-300">
                    <ArrowUpRight size={16} strokeWidth={2.4} />
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-7">
                  <h3 className="font-heading font-black text-2xl md:text-3xl tracking-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-zinc-300 leading-relaxed max-w-sm mb-5">
                    {s.desc}
                  </p>
                  <ul className="space-y-2 pt-4 border-t border-white/15">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="flex items-center gap-2 text-xs text-zinc-200 uppercase tracking-wider font-mono"
                      >
                        <Check
                          size={12}
                          className="text-[#E63946]"
                          strokeWidth={3}
                        />
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
